function offersOnload() {

    const topBar = document.getElementById('topBar');

    $(window).on('scroll', function () {
        const scroll = $(this).scrollTop();

        //paralax
        $('.ev_header_background').css(
            'transform',
            `translateY(${scroll * 0.3}px)`
        );

        // Progress bar
        const total = document.body.scrollHeight - window.innerHeight;
        const pct = (window.scrollY / total) * 100;
        topBar.style.width = pct + '%';

        //menu scroll
        if ($(this).scrollTop() > 400) {
            $('.header-scroll').addClass('show');
        } else {
            $('.header-scroll').removeClass('show');
        }
    });

    //form
    selectStateCity('state','city');



}